import * as React from "react";
import "./src/styles/global.css";
import { AudioProvider } from "./src/components/AudioProvider";

export const wrapRootElement = ({ element }) => {
  return <AudioProvider>{element}</AudioProvider>;
};
